<template>
  <v-content>
    <header>
      <meta name="viewport" content="width=device-width, initial-scale=1">
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    </header>
    <v-container
      fluid
      class="main--text"
      >
      <v-profile-setting-card
        v-model="inputValue"
        @submit-button-click="putParent"
        @address-button-click="searchAddress"
        @card-button-click="registerCard"/>
      <v-dialog
        :value="addressErr"
        width="400"
        persistent>
        <v-card>
          <v-container
            fluid
            grid-list-md>
            <v-layout
              justify-center>
              <v-flex>
                住所が見つかりませんでした。
              </v-flex>
            </v-layout>
            <v-layout
              justify-center
              >
              <v-btn
              depressed
              rounded
              outlined
              color="primary"
              @click="addressErr=false"
              >
                OK
              </v-btn>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog
        :value="cardOk"
        width="400"
        persistent>
        <v-card>
          <v-container
            fluid
            grid-list-md
            >
            <v-layout
              justify-center>
              <v-flex>
                カード情報が確認できました
              </v-flex>
            </v-layout>
            <v-layout
              justify-center
              >
              <v-btn
              depressed
              rounded
              outlined
              color="primary"
              @click="cardOk=false"
              >
                OK
              </v-btn>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog
        :value="cardErr"
        width="400"
        persistent>
        <v-card>
          <v-container
            fluid
            grid-list-md>
            <v-layout
              justify-center>
              <v-flex>
                無効なカード情報です。
              </v-flex>
            </v-layout>
            <v-layout
              justify-center
              >
              <v-btn
              depressed
              rounded
              outlined
              color="primary"
              @click="cardErr=false"
              >
                OK
              </v-btn>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-content>
</template>

<script>
import { app } from "@/core/firebase.js"
import { ParentRepository } from "@/repository/ParentRepository.js"
import { firestore } from "@/repository/client/firestore.js"
import VProfileSettingCard from "@/components/organisms/parent/VProfileSettingCard.vue"
import VUnloggedinBaseToolBar from "@/components/organisms/parent/VUnloggedInBaseToolBar.vue"
import { getAddress } from "@/core/geocoding"
import { storeCreditCard } from '@/core/paypal'

export default {
  components: {
    VProfileSettingCard,
    VUnloggedinBaseToolBar
  },
  data() {
    return {
      inputValue: {
        birthday: new Date(1990, 0, 1),
        prefecture: null,
        municipality: null,
        cardId: null
      },
      addressErr: false,
      cardOk: false,
      cardErr: false,
    }
  },
  methods: {
    async putParent() {
      const email = app.auth().currentUser.email

      const parent = await this.parentRepo.put({
        uuid: this.uuid,
        personalName: this.inputValue.personalName,
        familyName: this.inputValue.familyName,
        flatPersonalName: this.inputValue.flatPersonalName,
        flatFamilyName: this.inputValue.flatFamilyName,
        email: email,
        gender: this.inputValue.gender,
        birthday: this.inputValue.birthday,
        phone: this.inputValue.phone,
        postalCode: this.inputValue.postalCode,
        prefecture: this.inputValue.prefecture,
        municipality: this.inputValue.municipality,
        subAddress: this.inputValue.subAddress,
        nearestStation: this.inputValue.nearestStation ? this.inputValue.nearestStation : "なし",
        cardId: this.inputValue.cardId
      })
      this.$store.commit("loginAsParent", parent)
    },
    async searchAddress() {
      try {
        const result = await getAddress(this.inputValue.postalCode)
        this.inputValue.prefecture = result.prefecture
        this.inputValue.municipality = result.municipality
      } catch(e) {
        this.addressErr = true
      }
    },
    async registerCard (creditCard) {
      try {
        this.inputValue.cardId = await storeCreditCard(this.uuid, creditCard)
        this.cardOk = true
      } catch (e) {
        this.cardErr = true
      }
    }
  },
  created: function () {
    this.parentRepo = new ParentRepository(firestore)
  },
  computed: {
    uuid () {
      return app.auth().currentUser.uid
    }
  }
}
</script>
